var map = {
	"./1AGP.png": 83901,
	"./2AGP.png": 32015,
	"./3AGP.png": 11715,
	"components/Catalog/AGP/img/glass/t/tPlusBlack/1AGP.png": 83901,
	"components/Catalog/AGP/img/glass/t/tPlusBlack/2AGP.png": 32015,
	"components/Catalog/AGP/img/glass/t/tPlusBlack/3AGP.png": 11715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97885;